import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import {
    createDocUser,
    saveDocUser,
    fetchDocUser,
} from "../../reducers/doc_users/actions";
import { Form, Progress, RouteMatch } from "../../lib";
import { navigate } from "../../services";
import { UD_EDITOR, UD_AUTHOR, UD_REVIEWER } from "../../settings";
import { Editing, Fields, Constraints } from "./types";
import { AppState } from "../../store";

const Container = styled.div`
    margin: 0 auto 60px auto;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
`;

type OwnProps = {
    doc_id: number;
    user_id: number;
    editing: Editing;
    match: RouteMatch;
};
const mapStateToProps = (state: AppState, { doc_id, user_id }: OwnProps) => ({
    user: state.user,
    //@ts-ignore
    loggedInDocUser: state.doc_users.get(`${doc_id}-${state.user.get("id")}`),
    //@ts-ignore
    doc_user: state.doc_users.get(`${doc_id}-${user_id}`),
});
const mapDispatch = { createDocUser, saveDocUser, fetchDocUser };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;
type Props = StateProps & DispatchProps & OwnProps;

type State = {
    loading: boolean;
};

class DocUserForm extends React.Component<Props, State> {
    private order = ["name", "status"];
    private fields: Fields = {};
    private constraints: Constraints = {};

    constructor(props: Props) {
        super(props);

        this.state = {
            loading: true,
        };

        if (props.editing === "Edit") {
            this.fields = {
                name: {
                    type: "text",
                    readOnly: true,
                },
                status: {
                    type: "select",
                    value: UD_REVIEWER,
                    values: [UD_AUTHOR, UD_REVIEWER],
                },
            };
        } else {
            this.order = ["email", "status"];

            this.fields = {
                email: {
                    type: "text",
                },
                status: {
                    type: "select",
                    value: UD_REVIEWER,
                    values: [UD_AUTHOR, UD_REVIEWER],
                },
            };

            this.constraints = {
                email: {
                    presence: { message: "emailRequired" },
                    email: { message: "emailInvalid" },
                },
            };
        }
    }

    componentDidMount() {
        const { user, doc_id, user_id, editing } = this.props;

        // fetch user status, the one editing the form
        //@ts-ignore
        this.props.fetchDocUser({ doc_id, user_id: user.get("id") });

        if (editing === "Edit") {
            // fetching user in edit mode
            this.props.fetchDocUser({ doc_id, user_id });
        }
    }

    componentWillReceiveProps(nextProps: Props) {
        const { loggedInDocUser } = nextProps;
        if (loggedInDocUser) {
            const status = (loggedInDocUser as any).get("status");

            if (![UD_EDITOR, UD_AUTHOR].includes(status)) {
                return navigate.to("/app/docs");
            }

            let statusValues = [UD_EDITOR, UD_AUTHOR, UD_REVIEWER];
            if (status === UD_AUTHOR) {
                statusValues = [UD_AUTHOR, UD_REVIEWER];
            }
            this.fields.status.values = statusValues;

            this.setState({
                loading: false,
            });
        }
    }

    onSubmit = (values: Record<string, any>) => {
        const { editing, doc_id, user_id } = this.props;
        if (editing === "Edit") {
            this.props.saveDocUser({
                doc_id,
                user_id,
                data: values,
            });
        } else {
            // TODO
            this.props.createDocUser({
                doc_id,
                data: values,
            });
        }
    };

    onCancel = () => navigate.to(`/app/users/${this.props.doc_id}`);

    render() {
        if (this.state.loading) {
            return <Progress />;
        }

        return (
            <Container>
                <Form
                    id="userDoc"
                    heading="title"
                    updateProp="doc_user"
                    doc_user={this.props.doc_user}
                    order={this.order}
                    fields={this.fields}
                    constraints={this.constraints}
                    focusOnFirst={true}
                    editing={this.props.editing}
                    onSubmit={this.onSubmit}
                    onAlternate={this.onCancel}
                />
            </Container>
        );
    }
}

export default connect(mapStateToProps, mapDispatch)(DocUserForm);
